import { type SocialAssetWithProject } from '../../../shared/types';
import { STATUS_LABELS, type SocialCounters } from '../../lib/socialCalendar';
import { type SubView } from './types';

// ── Shared chrome ────────────────────────────────────────────────────────

export function SocialStatStrip({ counters }: { counters: SocialCounters }) {
  return (
    <div className="social-stats" data-social-strip>
      <div className="social-stat warn">
        <div className="n">{counters.planned}</div>
        <div className="l">planned · next 14 days</div>
      </div>
      <div className="social-stat good">
        <div className="n">{counters.ready}</div>
        <div className="l">ready &amp; unused</div>
      </div>
      <div className="social-stat warn">
        <div className="n">{counters.needsPrep}</div>
        <div className="l">needs prep</div>
      </div>
      <div className="social-stat bad">
        <div className="n">{counters.restricted}</div>
        <div className="l">restricted</div>
      </div>
    </div>
  );
}

export function StatusPill({ asset }: { asset: SocialAssetWithProject }) {
  if (asset.effective_restricted) return <span className="pill danger">restricted</span>;
  if (asset.status === 'used') return <span className="pill struck">used</span>;
  const tone = asset.status === 'ready' ? 'ok' : asset.status === 'needs_prep' ? 'gold' : 'accent';
  return <span className={`pill ${tone}`}>{STATUS_LABELS[asset.status]}</span>;
}

export function SocialEmpty({ view, onAdd }: { view: SubView; onAdd: () => void }) {
  return (
    <div className="social-empty">
      <div className="et">
        {view === 'library' ? 'Nothing in the library yet' : 'Nothing planned yet'}
      </div>
      {view === 'library' ? (
        <p>
          Add your first asset: a cut, BTS clip, stills export, or PTC. Link it to a project or
          leave it standalone. Once assets are in, the calendar and gap counters come alive.
        </p>
      ) : (
        <p>
          The calendar fills from the library. Add an asset over there, mark it ready, and it
          shows up here to slot into a date.
        </p>
      )}
      <p style={{ marginTop: 16 }}>
        <button type="button" className="btn primary" onClick={onAdd}>
          + Add asset
        </button>
      </p>
    </div>
  );
}

// ── Library ──────────────────────────────────────────────────────────────

export function FilterChip({
  label,
  on,
  onClick,
}: {
  label: string;
  on: boolean;
  onClick: () => void;
}) {
  return (
    <button type="button" className={`chip${on ? ' accent' : ''}`} aria-pressed={on} onClick={onClick}>
      {label}
    </button>
  );
}
